/* eslint-disable */
const EMAIL_REGEX_STRING =
  '(^[^\\.\\s@][^\\s@]*(?!\\.)@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+$)'
const PHONE_REGEX_STRING = '(^[ +.,)(\\d-]{8,23}$)'
const EMAIL_PHONE_REGEX_STRING = `(${EMAIL_REGEX_STRING})|(${PHONE_REGEX_STRING})`
const EMAIL_REGEX = new RegExp(EMAIL_REGEX_STRING)
const PHONE_REGEX = new RegExp(PHONE_REGEX_STRING)

const isEmail = makeRegexTester(EMAIL_REGEX)
const isPhone = makeRegexTester(PHONE_REGEX)
const isNetworkId = v => typeof v === 'string' && v[0] === '@'
const isPhoneOrEmail = val => isPhone(val) || isEmail(val)
const isNetworkIdOrEmail = val => isNetworkId(val) || isEmail(val)

// all exports here
// used by input `pattern` attributes
export {
  EMAIL_PHONE_REGEX_STRING,
  EMAIL_REGEX_STRING,
  isEmail,
  isPhone,
  isPhoneOrEmail,
  isNetworkIdOrEmail,
  isNetworkId,
}

// util functions
function makeRegexTester(regex) {
  return function testRegex(value) {
    return regex.test(value)
  }
}
